import { useState, useEffect, useRef } from "react";
import { GoChevronDown } from "react-icons/go";

function Dropdown({ options, value, label, onChange }) {

    const [isOpen, setIsOpen] = useState(false);
    const divEl = useRef(); // get a reference to the top-level div element

    useEffect(() => {
        const handler = (event) => {
            // If the div is currently hidden, do nothing
            if (!divEl.current) {
                return;
            }
            // if the user clicked on an area outside of the dropdown, close dropdown
            if (!divEl.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('click', handler, true); // adding "true" enables the capture phase

        // the following is the cleanup function, called when dropdown is removed
        return () => {
            document.removeEventListener('click', handler);
        };
    }, []);

    const handleClick = () => {
        setIsOpen(!isOpen);
        // setIsOpen((currentIsOpen) => !currentIsOpen); // the technically correct way to code this
    }

    const handleOptionClick = (option) => {
        setIsOpen(false);
        onChange(option);        
    }

    const renderedOptions = options.map((option) => {
        if (value?.label !== option.label) {
            return (
                <div 
                    onClick={() => handleOptionClick(option)} 
                    key={option.value}>{option.label}
                </div>)
        }
        
    })

    // Below code - || will return first truthy value - the "?" will change expression to undefined if null is passed
    // Below code - && will return first falsy or last truthy value, JS will not display null items
    return (
        <div ref={divEl} className="dropdown">
            <label>{label}</label>
            <div 
                className="dropbtn"     
                onClick={handleClick}
            >
                {value?.label || "Select...."}
                <GoChevronDown className="text-lg"/>
                
            </div>
            {isOpen && <div className="dropdown-content">{renderedOptions}</div>}
        </div>        
    ) 
}

export default Dropdown;